export function modelComparison() {
    const root = document.querySelector('.toptech-model-comparison');
    if (!root) return;

    const rows = Array.from(root.querySelectorAll('[data-model-row]'));
    const search = root.querySelector('[data-model-search]');
    const provider = root.querySelector('[data-model-provider]');
    const deployment = root.querySelector('[data-model-deployment]');
    const useCase = root.querySelector('[data-model-usecase]');
    const sortButtons = Array.from(root.querySelectorAll('[data-model-sort]'));
    const tbody = root.querySelector('tbody');
    const count = root.querySelector('[data-model-results]');
    const empty = root.querySelector('[data-model-empty]');

    if (window.jQuery) {
        window.jQuery(() => {
            window.setTimeout(() => {
                window.jQuery(root).find('select[data-native-select]').each((index, select) => {
                    const $select = window.jQuery(select);
                    if ($select.data('chosen')) $select.chosen('destroy');
                });
            }, 0);
        });
    }

    const update = () => {
        const query = search.value.trim().toLocaleLowerCase();
        let visible = rows.filter((row) => {
            const matches = row.dataset.search.includes(query)
                && (!provider.value || row.dataset.provider === provider.value)
                && (!deployment.value || row.dataset.deployment === deployment.value)
                && (!useCase.value || row.dataset.useCases.split(' ').includes(useCase.value));
            row.hidden = !matches;
            return matches;
        });

        const sort = sortButtons.find((button) => button.getAttribute('aria-pressed') === 'true')?.dataset.modelSort || 'provider';
        const direction = sort.endsWith('desc') ? -1 : 1;
        if (sort === 'price-asc' || sort === 'price-desc') {
            visible.sort((a, b) => {
                const left = Number(a.dataset.priceUsd);
                const right = Number(b.dataset.priceUsd);
                if (!left && !right) return a.cells[0].innerText.localeCompare(b.cells[0].innerText);
                if (!left) return 1;
                if (!right) return -1;
                return (left - right) * direction;
            });
        } else {
            visible.sort((a, b) => {
                const field = sort === 'provider' ? 'provider' : 'modelName';
                return a.dataset[field].localeCompare(b.dataset[field]) * direction;
            });
        }
        visible.forEach((row) => tbody.appendChild(row));
        count.textContent = `${visible.length} of ${rows.length} models shown`;
        empty.hidden = visible.length > 0;
    };

    [search, provider, deployment, useCase].forEach((control) => control.addEventListener('input', update));
    [provider, deployment, useCase].forEach((control) => control.addEventListener('change', update));
    sortButtons.forEach((button) => button.addEventListener('click', () => {
        sortButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        update();
    }));
}
